const grillPageRepair=location.pathname==='/collections/all'&&new URLSearchParams(location.search).get('view')==='grills' ? await import('./grill-card-repair.js') : null;
import {openCategoryConfigurator, mountConfigurationFields} from './category-configurator.js?v=0f20ddd147a51f57';
const {
  loadCategory,
  recommend,
  matchingVariants,
  readContext,
  writeContext,
  legacyState,
  addComparison,
  saveProject,
} = await import(
  document.querySelector("[data-category-journey]").dataset.core
);
const money = (c) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(c / 100);
const text = (tag, value, className) => {
  const el = document.createElement(tag);
  el.textContent = value;
  if (className) el.className = className;
  return el;
};
const download = (name, content) => window.HearthOutpostDocuments.text(name, content);
for (const root of document.querySelectorAll("[data-category-journey]"))
  initialize(root);
async function initialize(root) {
  const category = root.dataset.category,
    status = root.querySelector("[data-journey-status]"),
    dialog = root.querySelector("[data-config-dialog]"),
    expert = root.querySelector("[data-expert-dialog]");
  let data,
    family,
    variants = [],
    previousFocus;
  const finder = document.querySelector("[data-grill-finder]"),
    inputs = [...document.querySelectorAll("[data-journey-answer]")];
  const answers = () =>
    inputs.length
      ? Object.fromEntries(
          inputs.map((i) => [i.dataset.journeyAnswer, i.value]),
        )
      : readContext().preferences[category] || {};
  const catalogLayout = category === 'grills' && finder?.hasAttribute('data-grill-catalog');
  let marketRatings;
  const loadMarketRatings = () => marketRatings ||= (async () => {
    const request = async page => {
      const response = await fetch('/collections/all?view=grill-market-ratings&page=' + page, {signal:AbortSignal.timeout(20000)});
      if (!response.ok) throw Error('Product details could not be loaded. Please try again.');
      return response.json();
    };
    const first = await request(1);
    const pages = await Promise.all(Array.from({length:first.pages - 1}, (_, i) => request(i + 2)));
    const statuses = new Map([first,...pages].flatMap(page => page.products).map(product => [product.handle, product.status]));
    for (const family of data.families.filter(family => !statuses.has(family.handle))) {
      const response = await fetch('/products/' + encodeURIComponent(family.handle) + '?view=hop-card-rating', {signal:AbortSignal.timeout(12000)});
      if (!response.ok) throw Error('Product details could not be loaded. Please try again.');
      const rating = await response.json();
      statuses.set(family.handle, rating.market === null ? 'Not Rated' : 'Rated');
    }
    return statuses;
  })().catch(error => { marketRatings = null; throw error; });
  let configuredVariant;
  const current = () => configuredVariant;
  const open = (d) => {
    previousFocus = document.activeElement;
    d.showModal();
  };
  root
    .querySelectorAll("[data-dialog-close]")
    .forEach((b) =>
      b.addEventListener("click", () => b.closest("dialog").close()),
    );
  root
    .querySelectorAll("dialog")
    .forEach((d) => d.addEventListener("close", () => previousFocus?.focus()));
  const summary = () => {
    const state = legacyState(),
      book = state.projectBooks.find((b) => b.id === state.activeProjectId),
      context = readContext().projects[book.id];
    return [
      "HEARTH OUTPOST — GRILL PLANNING",
      `Prepared ${new Date().toLocaleDateString("en-US")}`,
      `${location.origin}/collections/projects`,
      ...Object.entries(answers())
        .filter(([, v]) => v)
        .map(([k, v]) => `${k}: ${v}`),
      `Project: ${book.name}`,
      ...book.items.map((i) => {
        const variant = data?.families
          .flatMap((f) => f.variants)
          .find((v) => v.key === i.sku);
        return variant
          ? `Selected grill: ${variant.sku} · quantity ${i.quantity}${i.note ? " · " + i.note : ""}`
          : "Additional saved project item — review in Projects.";
      }),
      ...(context?.categories?.grills?.unresolved || []).map(
        (i) => `Configuration still needed: ${i.title}`,
      ),
      "Confirm exact model dimensions, fuel, power and installation requirements before ordering.",
    ].join("\n");
  };
  root.querySelector("[data-expert-open]")?.addEventListener("click", () => {
    expert.querySelector("[data-expert-summary]").value = summary();
    open(expert);
  });
  root
    .querySelector("[data-expert-download]")
    .addEventListener("click", () =>
      download(
        "hearth-outpost-expert-request.txt",
        expert.querySelector("[data-expert-summary]").value +
          "\n\nQuestions:\n" +
          expert.querySelector("[data-expert-questions]").value,
      ),
    );
  function refresh() {
    const state = legacyState();
    root.querySelector("[data-journey-compare]").textContent =
      `${root.dataset.mode === "projects" ? "Open Grill Comparison Tool" : "Open grill comparison"}${state.compare.length ? ` (${state.compare.length}/4)` : ""}`;
    root.querySelector("[data-journey-compare]").href =
      "/collections/all?view=compare-grills" +
      (state.compare.length
        ? "&models=" + encodeURIComponent(state.compare.join(","))
        : "");
    renderProject();
  }
  function renderProject() {
    const host = root.querySelector("[data-project-context]");
    if (!host) return;
    host.replaceChildren();
    const state = legacyState(),
      book = state.projectBooks.find((b) => b.id === state.activeProjectId),
      context = readContext().projects[book.id]?.categories?.grills;
    if (!context) return;
    const box = text("section", "", "ho-journey-projects");
    box.append(
      text("h2", `Grill planning · ${book.name}`),
      text(
        "p",
        Object.entries(context.answers || {})
          .filter(([, v]) => v)
          .map(([k, v]) => `${k}: ${v}`)
          .join(" · ") || "Your saved grill shortlist.",
      ),
      text(
        "p",
        "Saved in this browser. Families below still need an exact configuration.",
      ),
    );
    const list = document.createElement("ul");
    for (const item of context.unresolved || []) {
      const li = text("li", item.title);
      const f = data?.families.find((f) => f.handle === item.handle);
      if (f) {
        const b = text(
          "button",
          "Choose configuration",
          "ho-button ho-button--text",
        );
        b.type = "button";
        b.addEventListener("click", () => configure(f));
        li.append(b);
      } else li.append(text("span", " — configuration details unavailable"));
      list.append(li);
    }
    box.append(list);
    const b = text(
      "button",
      "Download project brief",
      "ho-button ho-button--secondary",
    );
    b.type = "button";
    b.addEventListener("click", () =>
      download("hearth-outpost-project-brief.txt", summary()),
    );
    box.append(b);
    host.append(box);
  }
  function configure(f, choices, intent) {
    family = f;
    variants = choices?.length
      ? choices
      : f.variants.filter((v) => v.available);
    dialog.querySelector("[data-config-title]").textContent = f.title;
    mountConfigurationFields(dialog.querySelector('[data-config-fields]'),variants,variants[0],v=>{configuredVariant=v;renderConfiguration();});
    dialog.querySelector("[data-config-status]").textContent = "";
    dialog.querySelector("[data-config-details]").open =
      intent === "Planning details";
    renderConfiguration();
    open(dialog);
  }
  function renderConfiguration() {
    const v = current(),
      host = dialog.querySelector("[data-config-facts]");
    host.replaceChildren();
    dialog.querySelector("[data-config-options]").textContent = v
      ? [v.sku, ...Object.values(v.options)].join(" · ")
      : "";
    dialog.querySelector("[data-config-price]").textContent = v
      ? `${money(v.priceCents)} · current configuration price`
      : "No available configuration found.";
    for (const selector of [
      "[data-config-compare]",
      "[data-config-save]",
      "[data-config-download]",
    ])
      dialog.querySelector(selector).disabled = !v;
    const link = dialog.querySelector("[data-config-product]");
    link.href = v?.url || family.url;
    if (!v) return;
    const dl = document.createElement("dl");
    for (const [label, value] of [
      ["Fuel", v.fuel],
      ["Installation", v.installation],
      ...v.specs
        .filter((s) =>
          /cooking|cutout|dimension|width|depth|height|voltage|electrical/i.test(
            s.attribute,
          ),
        )
        .slice(0, 9)
        .map((s) => [s.attribute.replaceAll("_", " "), s.value]),
    ]) {
      dl.append(text("dt", label), text("dd", String(value)));
    }
    host.append(dl);
    if (v.documents.length)
      host.append(
        text(
          "p",
          "Documents to review on the product page: " +
            [...new Set(v.documents.map((d) => d.label))].join(" · "),
        ),
      );
  }

  dialog
    .querySelector("[data-config-compare]")
    .addEventListener("click", () => {
      const result = addComparison(
        category,
        current(),
        data.families.flatMap((f) => f.variants),
      );
      dialog.querySelector("[data-config-status]").textContent = result.message;
      refresh();
    });
  for (const [selector, exact] of [
    ["[data-config-save]", true],
    ["[data-config-later]", false],
  ])
    dialog.querySelector(selector).addEventListener("click", () => {
      const result = saveProject(
        category,
        family,
        exact ? current() : null,
        answers(),
      );
      dialog.querySelector("[data-config-status]").textContent = result.message;
      refresh();
    });
  dialog
    .querySelector("[data-config-download]")
    .addEventListener("click", () => {
      const v = current();
      download(
        "hearth-outpost-grill-brief.txt",
        summary() +
          `\n\n${family.title}\n${v.sku}\n${money(v.priceCents)} at time of preparation\n${location.origin}${v.url}\n` +
          v.specs
            .map((s) => `${s.attribute.replaceAll("_", " ")}: ${s.value}`)
            .join("\n"),
      );
    });
  function actions(host, f, choices) {
    if (host.querySelector("[data-journey-actions]")) return;
    const row = text("div", "", "ho-journey-actions");
    row.dataset.journeyActions = "";
    for (const label of ["Compare", "Configure", "Planning details"]) {
      const b = text("button", label);
      b.type = "button";
      b.addEventListener("click", () => {
        if(label === "Configure"){
          openCategoryConfigurator({family:f,variants:choices?.length?choices:f.variants,selected:choices?.[0],onSelect:v=>{const card=host.querySelector('.ho-product-card');if(card)card.href=v.url;const heading=host.querySelector('.ho-product-card h3');if(heading&&v.configurationTitle)heading.textContent=v.configurationTitle;const img=host.querySelector('img');if(img&&v.image){img.removeAttribute('srcset');img.src=v.image;}const price=host.querySelector('.ho-product-price');if(price)price.textContent=money(v.priceCents);host.dataset.configuredKey=v.key;const compareButton=row.querySelector('button');compareButton.textContent='Compare';compareButton.removeAttribute('aria-label');},onSave:v=>{const result=saveProject(category,f,v,{});status.textContent=result.message;refresh();return result.ok;}});return;
        }
        if (label !== "Compare") {
          configure(f, choices, label);
          return;
        }
        const shown =
          (choices||f.variants).find(v=>v.key===host.dataset.configuredKey) || choices?.[0] ||
          f.variants
            .filter((v) => v.available)
            .sort((a, b) => a.priceCents - b.priceCents)[0];
        if (!shown) {
          status.textContent = "No available configuration to compare.";
          return;
        }
        const result = addComparison(
          category,
          shown,
          data.families.flatMap((f) => f.variants),
        );
        status.textContent = result.message;
        b.textContent = result.ok ? "Added ✓" : "Compare";
        b.setAttribute(
          "aria-label",
          result.ok ? "Added to comparison" : "Compare",
        );
        refresh();
      });
      row.append(b);
    }
    host.append(row);
  }
  let ranked = [],
    visible = 0, renderEpoch = 0;
  const more = document.querySelector("[data-journey-more]");
  async function shortlist() {
    const host = document.querySelector("[data-journey-results]"),
      note = document.querySelector("[data-journey-result-status]");
    if (!host || !data) return;
    const selected = answers(),
      context = readContext();
    host.classList.toggle("ho-journey-results--bands", !catalogLayout && !selected.budget);
    context.preferences[category] = selected;
    const saved = writeContext(context);
    const epoch = ++renderEpoch;
    let ratings;
    if (catalogLayout && selected.market) {
      host.setAttribute('aria-busy','true');
      try { ratings = await loadMarketRatings(); }
      catch (error) { if (epoch === renderEpoch) { host.removeAttribute('aria-busy'); note.textContent = error.message; } return; }
      if (epoch !== renderEpoch) return;
    }
    // Preserve catalog order and all matched families; price bands do not drive this landing page.
    ranked = catalogLayout
      ? data.families.map(family => ({family, variants:matchingVariants(family,selected)}))
          .filter(result => result.variants.length && (!selected.market || ratings.get(result.family.handle) === selected.market))
      : recommend(data.families, selected);
    visible = 0;
    host.replaceChildren();
    note.textContent = ranked.length
      ? saved
        ? ""
        : "Preferences could not be saved in this browser."
      : "No configurations match every choice. Try a higher budget or remove a feature preference.";
    await appendResults(
      catalogLayout ? 20 : selected.budget
        ? 3
        : Math.max(1, ranked.filter((x) => x.featured).length),
    );
  }
  async function appendResults(amount) {
    const host = document.querySelector("[data-journey-results]");
    const found = ranked.slice(visible, visible + amount);
    const epoch=renderEpoch;
    if(grillPageRepair){
      more.disabled=true;host.setAttribute('aria-busy','true');
      try{for(let i=0;i<found.length;i+=3){await Promise.all(found.slice(i,i+3).map(async result=>{result.card=await grillPageRepair.repairCard(result.family);}));if(epoch!==renderEpoch)return;}}
      catch(error){if(epoch===renderEpoch){document.querySelector('[data-journey-result-status]').textContent=error.message;more.hidden=false;}return;}
      finally{if(epoch===renderEpoch){more.disabled=false;host.removeAttribute('aria-busy');}}
    }
    if(epoch!==renderEpoch)return;
    visible += found.length;
    for (const result of found) {
      const article = text("article");
      const template = document.createElement("template");
      template.innerHTML = result.card || result.family.card;
      article.append(template.content.cloneNode(true));
      const shown = result.variants[0];
      const card = article.querySelector(".ho-product-card");
      if (card) card.href = shown.url;
      const configurationTitle=article.querySelector(".ho-product-card h3");
      if(configurationTitle && shown.configurationTitle)configurationTitle.textContent=shown.configurationTitle;
      const img = article.querySelector("img");
      if (img && shown.image) {
        img.removeAttribute("srcset");
        img.src = shown.image;
        img.alt = result.family.title + " · " + shown.sku;
      }
      const price = article.querySelector(".ho-product-price");
      if (price) price.textContent = money(shown.priceCents);
      if (!catalogLayout && result.budgetCeiling)
        article.prepend(
          text(
            "p",
            `Up to ${money(result.budgetCeiling * 100)}`,
            "ho-home-eyebrow",
          ),
        );
      actions(article, result.family, result.variants);
      host.append(article);
    }
    if (more) {
      more.hidden = visible >= ranked.length;
      more.textContent = `Show ${Math.min(6, ranked.length - visible)} more grills`;
    }
  }
  more?.addEventListener("click", () => appendResults(6));
  const saved = { ...(readContext().preferences[category] || {}), budget: "" };
  for (const input of inputs) {
    if (
      [...input.options].some(
        (o) => o.value === saved[input.dataset.journeyAnswer],
      )
    )
      input.value = saved[input.dataset.journeyAnswer];
    input.dispatchEvent(new Event("change"));
  }
  inputs.forEach(input => input.addEventListener("change", shortlist));
  finder
    ?.querySelector("[data-journey-find]")
    ?.addEventListener("click", shortlist);
  finder
    ?.querySelector("[data-finder-reset]")
    ?.addEventListener("click", () => {
      inputs.forEach((i) => {
        i.value = "";
        i.dispatchEvent(new Event("change"));
      });
      const context = readContext();
      delete context.preferences[category];
      writeContext(context);
      document.querySelector("[data-journey-results]")?.replaceChildren();
      document.querySelector("[data-journey-result-status]").textContent = "";
      ranked = [];
      visible = 0;
      if (more) more.hidden = true;
      shortlist();
    });
  window.addEventListener("napoleon-saved", refresh);
  window.addEventListener("storage", refresh);
  refresh();
  try {
    data = await loadCategory(category, root.dataset.manifest);
    if(grillPageRepair)await grillPageRepair.addBroilmaster(data);
    // Derive brand choices from the same catalog used to build the shortlist.
    const brandInput = finder?.querySelector('[data-journey-answer="brand"]');
    if (brandInput) {
      const selectedBrand = brandInput.value || saved.brand || "";
      const allBrands = brandInput.options[0].cloneNode(true);
      const brands = [...new Set([
        ...data.families.map(f => f.brand),
        ...(catalogLayout ? [...brandInput.options].map(option => option.value) : [])
      ].filter(Boolean))].sort();
      brandInput.replaceChildren(allBrands, ...brands.map(brand => {
        const option = document.createElement("option");
        option.value = brand;
        option.textContent = brand;
        return option;
      }));
      brandInput.value = brands.includes(selectedBrand) ? selectedBrand : "";
      brandInput.dispatchEvent(new Event("change"));
    }
    status.textContent = "";
    finder?.querySelector("[data-journey-find]")?.setAttribute("hidden", "");
    await shortlist();
    document
      .querySelectorAll("#selected-grills .ho-product-card")
      .forEach((card) => {
        const f = data.families.find(
          (f) => f.handle === card.dataset.familyHandle,
        );
        if (f) actions(card.parentElement, f);
      });
    renderProject();
    root.dataset.ready = "true";
  } catch (e) {
    status.hidden = false;
    status.textContent = e.message + " Shopping links remain available.";
    const retry = text(
      "button",
      "Retry planning tools",
      "ho-button ho-button--text",
    );
    retry.type = "button";
    retry.addEventListener("click", () => location.reload());
    status.append(retry);
  }
}
